module.exports = __webpack_public_path__ + "img/bg.3d7d7959.png";